import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { FlexMiddle, User as BaseUser, Header2SemiBold, header2SemiBold } from '@ubeya/shared-web/components';
import { responsiveHide } from '@ubeya/shared-web/style';

const Wrapper = styled(FlexMiddle)`
  height: 41px;
  ${responsiveHide.tablet}
`;

const User = styled(BaseUser)`
  div {
    ${header2SemiBold};
  }
`;

const CardTitle = ({ firstName, lastName, image, mode }) => {
  if (mode === 'ADD') {
    return (
      <Wrapper>
        <Header2SemiBold>
          <Trans>addEmployee</Trans>
        </Header2SemiBold>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <User image={image} firstName={firstName} lastName={lastName} size="medium2" />
    </Wrapper>
  );
};

export default CardTitle;
